import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getuserInfo, reset } from "../components/StateSlices/getuserSlice";
import Spinner from "../components/Spinner/Spinner";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { PiCoatHangerFill } from "react-icons/pi";
import NoItem from "../assets/images/others_closet_empty.svg";
import loadImgGIf from "../assets/images/load-img.gif";
import { handleLike } from "../components/StateSlices/handleLikeSlice";
import "../components/ShopItem/ShopItem.css";
import { use } from "react";

const Favorites = () => {
  const [products, setProducts] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [likeArr, setLikeArr] = useState([]);

  const dispatch = useDispatch();

  const likeHandler = (id) => {
    let token = localStorage.getItem("clttoken");
    if (token) {
      setSpinner(true);
      dispatch(handleLike({ id, token }));
    }
  };

  const { status, userInfo, error, profile } = useSelector(
    (state) => state.user
  );

  const { likeMessage, likeStatus, likeError } = useSelector(
    (state) => state.like
  );

  useEffect(() => {
    if (!userInfo) {
      setSpinner(true);
      let token = localStorage.getItem("clttoken");
      if (token) {
        dispatch(getuserInfo({ token: token }));
      }
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      setSpinner(false);
      setProducts(userInfo.userProductsId.favouritesId);
      setLikeArr(
        userInfo.userProductsId.favouritesId.map((val) => val._id) || []
      );
      reset();
    }
  }, [userInfo]);

  useEffect(() => {
    // debugger
    if (likeStatus === "succeeded" && window.location.pathname === "/user/favorites") {
      const token = localStorage.getItem("clttoken");
      if (token) {
        dispatch(getuserInfo({ token: localStorage.getItem("clttoken") }));
      } else {
        setSpinner(false);
      }
    }
  }, [likeStatus]);

  const removeSpace = (url) => {
    return url.replace(/[\s#&\/]+/g, "-");
  };

  return (
    <>
      {spinner ? (
        <div style={{ width: "100%", height: "55vh", position: "relative" }}>
          <Spinner />
        </div>
      ) : (
        <div className="shop-items-con">
          {products && products.length > 0 ? (
            <>
              <div className="shop-items-con-wrapper" style={{ marginTop: 0 }}>
                {products.length > 0 &&
                  products.map((val, index) => {
                    let productCreatedAt = new Date(val.createdAt);
                    let currDate = new Date();
                    let timeDifference =
                      currDate.getTime() - productCreatedAt.getTime();
                    let numberOfDays = timeDifference / (1000 * 3600 * 24);
                    //consolele.log(parseInt(numberOfDays));

                    return (
                      <div className="shop-item-card">
                        {numberOfDays <= 30 && (
                          <>
                            {/* <div class="ribbon-pop small-text">Members Only</div> */}
                            <p class="ribbon">
                              <span class="text">Members Only</span>
                            </p>
                          </>
                        )}

                        <div className="card_image">
                          <Link
                            to={{
                              pathname: `/product/${encodeURIComponent(
                                removeSpace(val.productStats.brand)
                              )}-${encodeURIComponent(
                                removeSpace(val.productName)
                              )}/${val._id}`,
                              // search: `?product=${val._id}`,
                            }}
                            state={{ id: val._id }}
                            style={{ textDecoration: "none" }}
                            title={val.productName}
                          >
                            <LazyLoadImage
                              src={
                                val.productImage[0]
                                  ? val.productImage[0]
                                  : "https://propertywiselaunceston.com.au/wp-content/themes/property-wise/images/no-image.png"
                              }
                              // src={loadImgGIf}
                              alt="FP1"
                              effect="blur"
                              style={{ maxWidth: "250px" }}
                              height="260px"
                              placeholderSrc={loadImgGIf}
                            />
                          </Link>
                          <div
                            style={{
                              visibility: "visible",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "rgba(255,255,255,1)",
                              position: "absolute",
                              top: "0rem",
                              right: "1rem",
                              borderRadius: "50%",
                              width: "30px",
                              height: "30px",
                              opacity: 1,
                            }}
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              onClick={() => {
                                if (likeStatus !== "loading")
                                  likeHandler(val._id);
                              }}
                            >
                              {likeArr.includes(val._id) ? (
                                <AiFillHeart
                                  size={"1.2em"}
                                  color="var(--primary-color)"
                                  className="heart-icon"
                                />
                              ) : (
                                <AiOutlineHeart
                                  size={"1.2em"}
                                  color="var(--primary-color)"
                                  className="heart-icon heart-icon-animation"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <Link
                          to={{
                            pathname: `/product/${encodeURIComponent(
                              removeSpace(val.productStats.brand)
                            )}-${encodeURIComponent(
                              removeSpace(val.productName)
                            )}/${val._id}`,
                            // search: `?product=${val._id}`,
                          }}
                          state={{ id: val._id }}
                          style={{ textDecoration: "none" }}
                          title={val.productName}
                        >
                          <div className="card_text">
                            <div className="product_title h6">
                              {val.productName}
                            </div>
                            <hr
                              style={{
                                margin: "1rem .2rem",
                                borderStyle: "solid",
                                color: "#ddd",
                              }}
                            />
                            <div className="product_price h6 bold-text">
                              {val.productHanger}
                              <PiCoatHangerFill
                                style={{ marginLeft: "3px" }}
                                size={"1.3em"}
                              />{" "}
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </>
          ) : !spinner ? (
            <div className="no_item" style={{height: "55vh", marginTop: "1rem"}}>
              <img src={NoItem} alt="no-item-icon" style={{width: "100%", height: "500px"}} />
              <h3 className="h3" style={{color: "var(--background-color)"}}>
                No Items Found
              </h3>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default Favorites;
